export default __webpack_public_path__ + "static/media/003-arch of triumph.37c6c7b1.svg";